const SearchForm = () => {
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-search-form]');
    if (!form) return;

    e.preventDefault();

    const input = form.querySelector('[data-search-input]');
    const rawInput = form.querySelector('[data-search-raw]');
    const queryInput = form.querySelector('[data-search-query]');

    let query = input.value;
    rawInput.value = query;

    if (input.hasAttribute('data-prepend')) {
      query = input.dataset.prepend + query;
    }

    if (input.hasAttribute('data-append')) {
      let condition = input.dataset.condition || '';
      condition = condition ? ` ${condition}` : '';
      query = `${query}${condition} ${input.dataset.append}`;
    }

    queryInput.value = query;

    form.submit();
  });
};

export { SearchForm };
